import React from 'react';
import { ElementRenderer } from "./components/index.js";
import { useFormContext } from "./context/FormContext/index.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function FormRenderer({
  loading,
  showCheckmarks
}) {
  const {
    formConfiguration,
    watch,
    ...rest
  } = useFormContext();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: formConfiguration.map((element, index) => /*#__PURE__*/_jsx(ElementRenderer, {
      element: element,
      loading: loading,
      showCheckmark: showCheckmarks,
      ...rest
    }, element.id || `element-${index}`))
  });
}